// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gu","advertCardFooter__row":"c-a_gv","advertCardFooter__name":"c-a_gw","advertCardFooter__price":"c-a_gx","advertCardFooter__age":"c-a_gy"};